// src/components/ProductPage.jsx

import { useState } from 'react';
import { products } from '../Data/Product.js';
import ProductCard from './ProductCards.jsx';
import ProductListItem from './ProductListItem.jsx';
import SEOHelmet from './SEOHelmet';

function ProductPage() {
  const [viewMode, setViewMode] = useState('grid');
  const [openItemId, setOpenItemId] = useState(null);


  const handleToggleItem = (itemId) => {
    setOpenItemId(openItemId === itemId ? null : itemId);
  };

  return (
    <>
      <SEOHelmet
        title="Our Products - Premium Energy Drinks | Torque Energy"
        description="Explore Torque Energy's premium energy drink lineup. Clean, sustained energy without the crash. Available in multiple flavors for peak performance."
        keywords="energy drinks, torque products, energy drink flavors, clean energy drinks, premium energy"
        url="https://torqueenergy.shop/products"
      />
      <div className="container product-page-container">
        <div className="page-header">
          <h2>Our Products</h2>
          <div className="view-toggle">
            <button
              className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
            >
              <i className="fas fa-th-large"></i> Photo View
            </button>
            <button
              className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
            >
              <i className="fas fa-list"></i> Name View
            </button>
          </div>
        </div>

        {viewMode === 'grid' ? (
          <div className="product-grid">
            {products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="product-list">
            {products.map(product => (
              <ProductListItem
                key={product.id}
                product={product}
                isOpen={openItemId === product.id}
                onToggle={() => handleToggleItem(product.id)}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default ProductPage;